"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListboxGroup = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _useUniqueId = require("../utils/useUniqueId");
var _ListContext = require("./_ListContext");
var _listboxUtils = require("./_listboxUtils");
var _Listbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Listbox.css") : void 0);
var _excluded = ["ariaLabelledby", "children", "className", "label", "labelHeight", "labelRef", "stickyLabel"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CSS_BLOCK = 'sapcnqr-listbox';
var ListboxGroup = exports.ListboxGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context;
  var ariaLabelledby = props.ariaLabelledby,
    children = props.children,
    className = props.className,
    label = props.label,
    labelHeight = props.labelHeight,
    labelRef = props.labelRef,
    stickyLabel = props.stickyLabel,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Listbox.default);
  var labelId = (0, _useUniqueId.useUniqueId)();
  var listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  var _ref = listContextValue || {},
    isUsingGroups = _ref.isUsingGroups,
    size = _ref.size,
    gridLabelClassName = _ref.gridLabelClassName,
    isGrid = _ref.isGrid,
    orientation = _ref.orientation;
  var classes = classnames(className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__group"), isUsingGroups));
  var labelClasses = classnames("".concat(CSS_BLOCK, "__label"), gridLabelClassName, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "__label--")).call(_context, size), size !== 'lg'), "".concat(CSS_BLOCK, "__label--sticky-group"), !!stickyLabel));
  if (isGrid) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label ? /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: labelClasses,
      id: labelId,
      role: "presentation"
    }, label) : null, /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, otherProps, {
      "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
        ariaLabelledby: ariaLabelledby,
        label: label,
        labelId: labelId
      }),
      role: isUsingGroups ? 'group' : 'listbox',
      className: classes,
      ref: ref
    }), children));
  }
  var labelStyle;
  if (stickyLabel && labelHeight) {
    var styleProp = 'top';
    if (orientation === 'horizontal') styleProp = 'left';
    labelStyle = (0, _defineProperty2.default)({}, styleProp, "".concat(labelHeight, "px"));
  }
  return /*#__PURE__*/_react.default.createElement("ul", (0, _extends2.default)({}, otherProps, {
    "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
      ariaLabelledby: ariaLabelledby,
      label: label,
      labelId: labelId
    }),
    role: isUsingGroups ? 'group' : 'listbox',
    className: classes,
    ref: ref
  }), label ? /*#__PURE__*/_react.default.createElement("li", {
    "aria-hidden": "true",
    className: labelClasses,
    id: labelId,
    role: "presentation",
    style: labelStyle,
    ref: labelRef
  }, label) : null, children);
});
ListboxGroup.displayName = 'Listbox.Group';
ListboxGroup.propTypes = {
  ariaLabelledby: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  label: _propTypes.default.node,
  stickyLabel: _propTypes.default.bool,
  labelHeight: _propTypes.default.number,
  labelRef: _propTypes.default.object
};
var _default = exports.default = ListboxGroup;